module.exports = __webpack_public_path__ + "img/john.f38a436a.gif";